import logo from './logo.svg';
import './App.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import About from './Pages/About';
import Skill from './Pages/Skill';
import Project from './Pages/Project';
import Loader from './Components/Loader';
import Admin from './Pages/Admin';
import { useState } from 'react';

function App() {
  const[showLoader, setShowLoader] = useState(false);
  return (
    <BrowserRouter>
    {showLoader ? <Loader/> : null}
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/about-me' element={<About />} />
        <Route path='/skill' element={<Skill />} />
        <Route path='/projects' element={<Project />} />
        <Route path='/admin' element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}
  
export default App;
